import React from "react";
import {
  f7,
  Page,
  Link,
  Navbar,
  NavTitle,
  NavRight,
  Button,
  Badge,
  Toolbar,
  Tabs,
  Tab,
  Block,
  BlockTitle,
  Popup,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  List,
  ListItem,
  ListItemCell,
  ListInput,
  Icon,
  Range,
  Row,
  Col,
  Input,
  AccordionItem,
  AccordionToggle,
  AccordionContent,
} from "framework7-react";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import DeliveryPriceCountry from "../components/deliveryPriceCountry";
import { withFirestore, firestoreConnect } from "../HOCs";
import {
  toast,
  handleErrors,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from "../utils/_helpers";
import { Collections } from "../utils/_classes";
import countries from "../static/countries.json";
import cities from "../static/ng.json";

class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },
      tabName: "All Users",
      deliveryInclusiveLimit: "",
      defaultSearchRadius: "",
      defaultDeliveryCharge: "",
      deliveryChargeMultiplier: {
        1: 1,
        2: "",
      },
      perKmDeliveryCharge: "",
      percentageOrdersBelowAThousand: "",
      percentageOrdersAboveAThousand: "",
      delieryCityForm: false,
      deliveryCityCountrySearch: "",
      deliveryCityPrice: {
        country: "Nigeria",
        state: "",
        city: "",
        below2Km: 0,
        perKm: 0,
      },
    };
  }

  render() {
    return (
      <Page pageContent={false}>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding> {this.state.tabName}</NavTitle>
          <NavRight>
            <Button
              iconF7="gear_alt"
              onClick={() => {
                this.setState({
                  popupOpened: true,
                  popupDataChanged: true,
                  popupData: {
                    title: "Platform Settings",
                    which: "settings",
                  },
                });
              }}
            ></Button>
          </NavRight>
        </Navbar>

        <Tabs animated style={{ overflowY: "scroll" }} routable>
          <Tab className="page-content" id="all-users"></Tab>
          <Tab className="page-content" id="all-vendors"></Tab>
          <Tab
            className="page-content"
            id="all-wallets"
            onTabShow={() => this.walletsTab()}
          ></Tab>
          <Tab className="page-content" id="all-sales"></Tab>
        </Tabs>

        <Toolbar tabbar bottom id="admin-tab" label>
          <Link
            tabLink
            href="./"
            iconF7="person_2_square_stack"
            text="Users"
            routeTabId="all-users"
            onClick={() =>
              this.setState({ ...this.state, tabName: "All Users" })
            }
          />
          <Link
            tabLink
            href="all-vendors/"
            iconF7="briefcase"
            text="Vendors"
            routeTabId="all-vendors"
            onClick={() =>
              this.setState({ ...this.state, tabName: "All Vendors" })
            }
          />
          <Link
            tabLink
            href="all-wallets/"
            iconF7="creditcard"
            text="Wallets"
            routeTabId="all-wallets"
            onClick={() =>
              this.setState({ ...this.state, tabName: "All Wallets" })
            }
          />
          <Link
            tabLink
            href="all-sales/"
            iconF7="chart_bar"
            text="Sales"
            routeTabId="all-sales"
            onClick={() =>
              this.setState({ ...this.state, tabName: "All Sales" })
            }
          >
            {this.props.ordered.orders &&
            this.props.ordered.orders.filter(
              (o) => o.orderStatus === "Order Pending",
            ).length > 0 ? (
              <Badge
                color="red"
                style={{ position: "absolute", top: 0, left: "50%" }}
              >
                {this.props.ordered.orders &&
                  this.props.ordered.orders.filter(
                    (o) => o.orderStatus === "Order Pending",
                  ).length}
              </Badge>
            ) : null}
          </Link>
        </Toolbar>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
              deliveryInclusiveLimit: "",
              defaultSearchRadius: "",
              defaultDeliveryCharge: "",
              deliveryChargeMultiplier: this.deliveryChargeMultiplierReset(),
              perKmDeliveryCharge: "",
              percentageOrdersBelowAThousand: "",
              percentageOrdersAboveAThousand: "",
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for viewing platform settings */}
            {this.state.popupData.which == "settings" ? (
              <div>
                <Block className="pattern-banner bg-color-theme">
                  <Card style={{ width: "100%", margin: 0 }}>
                    <CardHeader>
                      <h3 style={{ margin: 0 }}>Default Platform Settings</h3>
                    </CardHeader>
                  </Card>
                </Block>

                <Block>
                  {/* search radius */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <CardHeader>Default search radius</CardHeader>
                    <CardContent>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="car_fill"></Icon>
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <Range
                              value={
                                this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .defaultSearchRadius
                                  : 50
                              }
                              step={5}
                              min={0}
                              max={100}
                              label={true}
                              onRangeChanged={(e) => {
                                this.$f7.$("#default-radius").text(e);
                                this.setState({
                                  ...this.state,
                                  defaultSearchRadius: e,
                                });
                              }}
                            ></Range>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              <span id="default-radius">
                                {this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .defaultSearchRadius
                                  : 50}
                              </span>
                              km
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>

                  {/* orders range 1000 - 5000 */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <CardHeader>
                      % Orders above NGN1,000 and below NGN5,000
                    </CardHeader>
                    <CardContent>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="creditcard"></Icon>
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <p>Service charge</p>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-4">
                            <input
                              type="number"
                              style={{
                                textAlign: "center",
                              }}
                              placeholder={
                                this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .percentageOrdersAboveAThousand
                                  : 500
                              }
                              value={this.state.percentageOrdersAboveAThousand}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  percentageOrdersAboveAThousand:
                                    e.target.value,
                                })
                              }
                            />
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              [
                              <span id="default-delivery-charge">
                                %
                                {this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .percentageOrdersAboveAThousand
                                  : 3.95}
                              </span>
                              ]
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>

                  {/* orders below 1000 */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <CardHeader>% Orders below NGN1,000</CardHeader>
                    <CardContent>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="creditcard"></Icon>
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <p>Service charge</p>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-4">
                            <input
                              type="number"
                              style={{
                                textAlign: "center",
                              }}
                              placeholder={
                                this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .percentageOrdersBelowAThousand
                                  : 500
                              }
                              value={this.state.percentageOrdersBelowAThousand}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  percentageOrdersBelowAThousand:
                                    e.target.value,
                                })
                              }
                            />
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              [
                              <span id="default-delivery-charge">
                                %
                                {this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .percentageOrdersBelowAThousand
                                  : 50}
                              </span>
                              ]
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>

                  {/* Inclusive delivery products */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <CardHeader>
                      Products With Delivery Price Inclusive Limit
                    </CardHeader>
                    <CardContent>
                      <List simpleList>
                        <ListItem>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <Icon f7="car_fill"></Icon>
                          </ListItemCell>
                          <ListItemCell className="flex-shrink-3">
                            <Range
                              value={
                                this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .deliveryInclusiveLimit
                                  : 10
                              }
                              step={1}
                              min={0}
                              max={20}
                              label={true}
                              onRangeChanged={(e) => {
                                this.$f7.$("#delivery-inclusive-limit").text(e);
                                this.setState({
                                  ...this.state,
                                  deliveryInclusiveLimit: e,
                                });
                              }}
                            ></Range>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              <span id="delivery-inclusive-limit">
                                {this.props.data.settings
                                  ? this.props.data.settings["easychaw"]
                                      .deliveryInclusiveLimit
                                  : 10}
                              </span>
                              km
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>

                  {/* Delivery means */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <AccordionItem
                      onAccordionOpened={(_) => {
                        document.getElementById(
                          "delivery-means",
                        ).style.transform = "rotate(180deg)";
                      }}
                      onAccordionClosed={(_) => {
                        document.getElementById(
                          "delivery-means",
                        ).style.transform = "rotate(0deg)";
                      }}
                    >
                      <AccordionToggle>
                        <CardHeader className="no-border">
                          <span>Default Delivery Prices</span>
                          <span>
                            <Button
                              outline
                              iconF7="arrowtriangle_down_fill"
                              id="delivery-means"
                            ></Button>
                          </span>
                        </CardHeader>
                      </AccordionToggle>
                      <AccordionContent>
                        <CardContent
                          className="bg-color-cultured"
                          style={{ padding: "8px" }}
                        >
                          <Row>
                            <Col width="100">
                              <Card
                                className="elevation-0"
                                style={{ margin: "8px" }}
                                title="Bike Delivery"
                              >
                                <CardContent>
                                  <img
                                    src="static/bike.svg"
                                    alt="bike"
                                    style={{
                                      height: "60px",
                                      width: "100%",
                                      marginBottom: "40px",
                                    }}
                                  />
                                  <List simpleList>
                                    <ListItem>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <Icon f7="creditcard"></Icon>
                                      </ListItemCell>
                                      <ListItemCell className="flex-shrink-3">
                                        <p>Below 2km</p>
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-4">
                                        <input
                                          type="number"
                                          style={{
                                            textAlign: "center",
                                          }}
                                          placeholder={
                                            this.props.data.settings
                                              ? this.props.data.settings[
                                                  "easychaw"
                                                ].defaultDeliveryCharge
                                              : 500
                                          }
                                          value={
                                            this.state.defaultDeliveryCharge
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              ...this.state,
                                              defaultDeliveryCharge:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <h6>
                                          [
                                          <span id="default-delivery-charge">
                                            NGN{" "}
                                            {this.state.defaultDeliveryCharge
                                              ? this.state.defaultDeliveryCharge
                                              : this.props.data.settings
                                              ? this.props.data.settings[
                                                  "easychaw"
                                                ].defaultDeliveryCharge
                                              : 500}
                                          </span>
                                          {"<= 2km"}]
                                        </h6>
                                      </ListItemCell>
                                    </ListItem>

                                    <ListItem>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <Icon f7="creditcard"></Icon>
                                      </ListItemCell>
                                      <ListItemCell className="flex-shrink-3">
                                        <p>1 kilometer charge</p>
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-4">
                                        <input
                                          type="number"
                                          style={{
                                            textAlign: "center",
                                          }}
                                          placeholder={
                                            this.props.data.settings
                                              ? this.props.data.settings[
                                                  "easychaw"
                                                ].perKmDeliveryCharge
                                              : 500
                                          }
                                          value={this.state.perKmDeliveryCharge}
                                          onChange={(e) =>
                                            this.setState({
                                              ...this.state,
                                              perKmDeliveryCharge:
                                                e.target.value,
                                            })
                                          }
                                        />
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <h6>
                                          [
                                          <span id="default-delivery-charge">
                                            NGN{" "}
                                            {this.state.perKmDeliveryCharge
                                              ? this.state.perKmDeliveryCharge
                                              : this.props.data.settings
                                              ? this.props.data.settings[
                                                  "easychaw"
                                                ].perKmDeliveryCharge
                                              : 50}
                                          </span>{" "}
                                          per km]
                                        </h6>
                                      </ListItemCell>
                                    </ListItem>
                                  </List>
                                </CardContent>
                              </Card>
                            </Col>

                            <Col width="100">
                              <Card
                                className="elevation-0"
                                style={{ margin: "8px" }}
                                title="Car Delivery"
                              >
                                <CardContent>
                                  <img
                                    src="static/car.svg"
                                    alt="car"
                                    style={{
                                      height: "60px",
                                      width: "100%",
                                      marginBottom: "40px",
                                    }}
                                  />
                                  <List simpleList>
                                    <ListItem>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <Icon f7="creditcard"></Icon>
                                      </ListItemCell>
                                      <ListItemCell className="flex-shrink-3">
                                        <p>Below 2km</p>
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <h6>
                                          [
                                          <span>
                                            NGN{" "}
                                            {this.props.data.settings
                                              ? Math.round(
                                                  (this.state
                                                    .defaultDeliveryCharge ||
                                                    this.props.data.settings[
                                                      "easychaw"
                                                    ].defaultDeliveryCharge) *
                                                    (this.state
                                                      .deliveryChargeMultiplier[
                                                      "2"
                                                    ] ||
                                                      this.props.data.settings[
                                                        "easychaw"
                                                      ]
                                                        ?.deliveryChargeMultiplier?.[
                                                        "2"
                                                      ] ||
                                                      1),
                                                  2,
                                                )
                                              : 500}
                                          </span>
                                          {"<= 2km"}]
                                        </h6>
                                      </ListItemCell>
                                    </ListItem>

                                    <ListItem>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <Icon f7="creditcard"></Icon>
                                      </ListItemCell>
                                      <ListItemCell className="flex-shrink-3">
                                        <p>1 kilometer charge</p>
                                      </ListItemCell>
                                      <ListItemCell className="width-auto flex-shrink-0">
                                        <h6>
                                          [
                                          <span>
                                            NGN{" "}
                                            {this.props.data.settings
                                              ? Math.round(
                                                  (this.state
                                                    .perKmDeliveryCharge ||
                                                    this.props.data.settings[
                                                      "easychaw"
                                                    ].perKmDeliveryCharge) *
                                                    (this.state
                                                      .deliveryChargeMultiplier[
                                                      "2"
                                                    ] ||
                                                      this.props.data.settings[
                                                        "easychaw"
                                                      ]
                                                        ?.deliveryChargeMultiplier?.[
                                                        "2"
                                                      ] ||
                                                      1),
                                                  2,
                                                )
                                              : 50}
                                          </span>{" "}
                                          per km]
                                        </h6>
                                      </ListItemCell>
                                    </ListItem>
                                  </List>
                                </CardContent>
                                <CardFooter>
                                  <span>Default Multiplier</span>
                                  <Input
                                    type="number"
                                    placeholder={`${
                                      this.props.data.settings?.["easychaw"]
                                        ?.deliveryChargeMultiplier?.["2"] || ""
                                    }`}
                                    value={
                                      this.state.deliveryChargeMultiplier["2"]
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        deliveryChargeMultiplier: {
                                          ...this.state
                                            .deliveryChargeMultiplier,
                                          2: e.target.value,
                                        },
                                      })
                                    }
                                    outline
                                    style={{ width: "20%" }}
                                  />
                                </CardFooter>
                              </Card>
                            </Col>
                          </Row>
                        </CardContent>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>

                  {/* Default City Delivery Prices */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <AccordionItem
                      onAccordionOpened={(_) => {
                        document.getElementById(
                          "delivery-prices",
                        ).style.transform = "rotate(180deg)";
                      }}
                      onAccordionClosed={(_) => {
                        document.getElementById(
                          "delivery-prices",
                        ).style.transform = "rotate(0deg)";
                      }}
                    >
                      <AccordionToggle>
                        <CardHeader className="no-border">
                          <span>City Delivery Price</span>
                          <span>
                            <Button
                              outline
                              iconF7="arrowtriangle_down_fill"
                              id="delivery-prices"
                            ></Button>
                          </span>
                        </CardHeader>
                      </AccordionToggle>
                      <AccordionContent>
                        <CardContent className="bg-color-white no-padding">
                          <Row>
                            {/* Show all cities */}
                            <Col width={100} className="cities-prices">
                              <Card className="m-0">
                                <CardHeader className="p-16 justify-start items-center">
                                  <Icon
                                    f7="search"
                                    style={{ width: 18, height: 18 }}
                                  />
                                  <Input
                                    type="text"
                                    placeholder="Search for country..."
                                    className="px-8 flex-grow"
                                    value={this.state.deliveryCityCountrySearch}
                                    onChange={(e) =>
                                      this.setState({
                                        ...this.state,
                                        deliveryCityCountrySearch:
                                          e.target.value,
                                      })
                                    }
                                  />
                                </CardHeader>
                                <CardContent className="p-8 bg-color-shadowblue">
                                  {Object.keys(
                                    this.props.data.settings.easychaw
                                      .deliveryChargesPerCity,
                                  ).length ? (
                                    Object.keys(
                                      this.props.data.settings.easychaw
                                        .deliveryChargesPerCity,
                                    )
                                      .filter((country) =>
                                        country
                                          .toLowerCase()
                                          .includes(
                                            this.state.deliveryCityCountrySearch.toLowerCase(),
                                          ),
                                      )
                                      .sort()
                                      .map((country) => (
                                        <DeliveryPriceCountry
                                          key={country}
                                          country={country}
                                          states={
                                            this.props.data.settings.easychaw
                                              .deliveryChargesPerCity?.[country]
                                          }
                                          deleteDeliveryPrice={this.deleteDeliveryPrice.bind(
                                            this,
                                          )}
                                          editDeliveryPrice={this.editDeliveryPrice.bind(
                                            this,
                                          )}
                                        />
                                      ))
                                  ) : (
                                    <Block className="block-info">
                                      <small>
                                        All cities are currently using default
                                        delivery price
                                      </small>
                                    </Block>
                                  )}
                                </CardContent>
                              </Card>
                            </Col>

                            {/* Form for cities */}
                            {this.state.delieryCityForm && (
                              <>
                                <Col width={100} className="bg-color-white">
                                  <List
                                    noHairlinesMd
                                    style={{ margin: "16px auto" }}
                                  >
                                    <ListInput
                                      label="Country"
                                      type="select"
                                      placeholder="Please select country"
                                      info="Select country from dropdown"
                                      required
                                      value={
                                        this.state.deliveryCityPrice.country
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryCityPrice: {
                                            ...this.state.deliveryCityPrice,
                                            country: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <option></option>
                                      {/* TODO: Load country array */}
                                      {countries
                                        .sort()
                                        .map((countryName, i) => (
                                          <option key={i} value={countryName}>
                                            {countryName}
                                          </option>
                                        ))}
                                      <Icon f7="globe" slot="media" />
                                    </ListInput>

                                    <ListInput
                                      label="State/Region"
                                      type="select"
                                      placeholder="Please select state"
                                      info="Select state from dropdown"
                                      required
                                      value={this.state.deliveryCityPrice.state}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryCityPrice: {
                                            ...this.state.deliveryCityPrice,
                                            state: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <option></option>
                                      {/* TODO: Load states/region array */}
                                      {[
                                        ...new Set([
                                          ...cities
                                            .filter(
                                              ({ country }) =>
                                                country ===
                                                this.state.deliveryCityPrice
                                                  .country,
                                            )
                                            .map(
                                              ({ admin_name }) => admin_name,
                                            ),
                                        ]),
                                      ]
                                        .sort()
                                        .map((state, i) => (
                                          <option key={i} value={state}>
                                            {state}
                                          </option>
                                        ))}
                                      <Icon f7="globe" slot="media" />
                                    </ListInput>

                                    <ListInput
                                      label="City"
                                      type="select"
                                      placeholder="Please select city"
                                      info="Select city from dropdown"
                                      required
                                      value={this.state.deliveryCityPrice.city}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryCityPrice: {
                                            ...this.state.deliveryCityPrice,
                                            city: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <option></option>
                                      {/* TODO: Load cities array */}
                                      {this.state.deliveryCityPrice.state &&
                                        cities
                                          .filter(
                                            ({ admin_name }) =>
                                              admin_name ===
                                              this.state.deliveryCityPrice
                                                .state,
                                          )
                                          .map(({ city }) => city)
                                          .filter(
                                            (city) =>
                                              !this.props.data.settings
                                                ?.easychaw
                                                ?.deliveryChargesPerCity?.[
                                                this.state.deliveryCityPrice
                                                  .country
                                              ]?.[
                                                this.state.deliveryCityPrice
                                                  .state
                                              ]?.[city],
                                          )
                                          .sort()
                                          .map((cityName, i) => (
                                            <option key={i} value={cityName}>
                                              {cityName}
                                            </option>
                                          ))}
                                      <Icon f7="globe" slot="media" />
                                    </ListInput>

                                    <ListInput
                                      label="Below 2km"
                                      type="number"
                                      placeholder="Price below 2km"
                                      info="Enter delivery price below 2km"
                                      required
                                      value={
                                        this.state.deliveryCityPrice.below2Km
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryCityPrice: {
                                            ...this.state.deliveryCityPrice,
                                            below2Km: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <Icon f7="creditcard" slot="media" />
                                    </ListInput>

                                    <ListInput
                                      label="1 kilometer"
                                      type="number"
                                      placeholder="Price per km"
                                      info="Enter delivery price per km"
                                      required
                                      value={this.state.deliveryCityPrice.perKm}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryCityPrice: {
                                            ...this.state.deliveryCityPrice,
                                            perKm: e.target.value,
                                          },
                                        })
                                      }
                                    >
                                      <Icon f7="creditcard" slot="media" />
                                    </ListInput>
                                  </List>
                                </Col>
                                <Col
                                  width={100}
                                  className="p-16 bg-color-gray-100"
                                >
                                  <Button
                                    fill
                                    className="button-fill-green"
                                    onClick={this.addDeliveryCityPrice.bind(
                                      this,
                                    )}
                                  >
                                    {`Add ${this.state.deliveryCityPrice.city} Delivery Price`}
                                  </Button>
                                </Col>
                              </>
                            )}
                          </Row>
                        </CardContent>
                        <CardFooter>
                          <span>Add New City Delivery Price</span>
                          <Button
                            outline
                            iconF7={
                              !this.state.delieryCityForm
                                ? "globe"
                                : "eye_slash"
                            }
                            onClick={() => {
                              this.setState({
                                ...this.state,
                                delieryCityForm: !this.state.delieryCityForm,
                              });
                            }}
                          >
                            &nbsp;&nbsp;&nbsp;
                            {!this.state.delieryCityForm
                              ? "Add City"
                              : "Hide Form"}
                          </Button>
                        </CardFooter>
                      </AccordionContent>
                    </AccordionItem>
                  </Card>

                  {/* save settings */}
                  <Card style={{ width: "100%", margin: "20pt auto" }}>
                    <CardHeader>Save Settings</CardHeader>
                    <CardContent>
                      <Button
                        fill
                        className="button-fill-blue"
                        onClick={(e) => this.changeDefaultSettings()}
                      >
                        Save
                      </Button>
                    </CardContent>
                  </Card>
                </Block>
              </div>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //   Events
  walletsTab() {
    const self = this;
    setTimeout(function () {
      var h = self.$f7.$(".heightMeasure-1").height();
      self.$f7.$(".heightRecieve-1").css({ height: `${h}px` });
    }, 1000);
  }

  // delivery charge multiplier reset
  deliveryChargeMultiplierReset() {
    return {
      1: 1,
      2: "",
    };
  }

  // life cycle
  componentDidMount() {
    this.props.firestore
      .collection("settings")
      .doc("easychaw")
      .get()
      .then((doc) => {
        if (!doc.exists) {
          this.props.firestore
            .collection("settings")
            .doc("easychaw")
            .set({
              defaultDeliveryCharge: 500,
              deliveryInclusiveLimit: 10,
              defaultSearchRadius: 50,
              perKmDeliveryCharge: 50,
              deliveryChargeMultiplier: {
                1: 1,
              },
              percentageOrdersBelowAThousand: 2.55,
              percentageOrdersAboveAThousand: 3.95,
            })
            .catch((error) => {
              toast(this.$f7.toast, {
                text: "Unable to set defaults. Please click on settings and set defaults",
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            });
        }
      })
      .catch((error) => {});
  }

  async deleteDeliveryPrice(country, state, city) {
    this.$f7.preloader.show();
    try {
      delete this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
        country
      ]?.[state]?.[city];

      const updateData = {
        ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity,
      };

      const idToken = await this.props.firebase
        .auth()
        .currentUser.getIdToken(true);
      sendEasychawOneTimePassword(
        { token: idToken, uid: this.props.auth.uid },
        (error, sent) => {
          if (error || !sent) {
            throw error;
          }

          this.$f7.preloader.hide();
          this.$f7.dialog
            .create({
              title: "OTP CODE",
              cssClass: "otp-code-modal",
              text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
              content: `<input class="dialog-input-for-per-city split-input" type="password" maxlength="4" />`,
              buttons: [
                // button to resend otp
                {
                  text: "Resend Code",
                  color: "gray",
                  cssClass: "otp-resend",

                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    sendEasychawOneTimePassword(
                      {
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, sent) => {
                        if (error || !sent) {
                          throw error;
                        }

                        this.$f7.preloader.hide();
                        return toast(this.$f7.toast, {
                          text: "OTP code sent",
                          position: "bottom",
                          horizontalPosition: "center",
                          closeButton: true,
                          cssClass: "custom-toast",
                          closeTimeout: 4000,
                        });
                      },
                    );
                  },
                },
                // button to cancel
                {
                  text: "x",
                  color: "white",
                  cssClass: "otp-close",
                  onClick: (dialog, e) => {
                    this.$f7.preloader.hide();
                  },
                },
                // button to continue
                {
                  text: "Continue",
                  bold: true,
                  cssClass: "otp-continue",
                  keyCodes: [13],
                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    // password
                    const password = dialog.$el
                      .find(".dialog-input-for-per-city")
                      .val();

                    // Verify otp
                    verifyEasychawOneTimePassword(
                      {
                        password,
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, success) => {
                        if (error || !success) {
                          throw error;
                        }

                        // close dialog
                        dialog.close();
                        this.props.firestore
                          .collection("settings")
                          .doc("easychaw")
                          .update({ deliveryChargesPerCity: updateData })
                          .then(() => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: `Settings updated`,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                            this.setState({
                              ...this.state,
                              deliveryCityPrice: {
                                country: "Nigeria",
                                state: "",
                                city: "",
                                below2Km: 0,
                                perKm: 0,
                              },
                            });
                          })
                          .catch((error) => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          });
                      },
                    );
                  },
                },
              ],
            })
            .open();
        },
      );
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async editDeliveryPrice(country, state, city, data) {
    this.$f7.preloader.show();
    try {
      if (!Object.keys(data).length) throw new Error(`Invalid field`);
      for (let key in data) {
        if (key === "deliveryCharge" || key === "kmPerDeliveryCharge") {
          if (isNaN(Number(data[key])) || Number(data[key]) <= 0) {
            throw new Error(`Invalid field: ${key}`);
          }
        }
      }

      const updateData = {
        ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity,
        [country]: {
          ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
            country
          ],
          [state]: {
            ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
              country
            ]?.[state],
            [city]: {
              ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
                country
              ]?.[state]?.[city],
              ...data,
            },
          },
        },
      };

      const idToken = await this.props.firebase
        .auth()
        .currentUser.getIdToken(true);
      sendEasychawOneTimePassword(
        { token: idToken, uid: this.props.auth.uid },
        (error, sent) => {
          if (error || !sent) {
            throw error;
          }

          this.$f7.preloader.hide();
          this.$f7.dialog
            .create({
              title: "OTP CODE",
              cssClass: "otp-code-modal",
              text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
              content: `<input class="dialog-input-for-per-city split-input" type="password" maxlength="4" />`,
              buttons: [
                // button to resend otp
                {
                  text: "Resend Code",
                  color: "gray",
                  cssClass: "otp-resend",

                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    sendEasychawOneTimePassword(
                      {
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, sent) => {
                        if (error || !sent) {
                          throw error;
                        }

                        this.$f7.preloader.hide();
                        return toast(this.$f7.toast, {
                          text: "OTP code sent",
                          position: "bottom",
                          horizontalPosition: "center",
                          closeButton: true,
                          cssClass: "custom-toast",
                          closeTimeout: 4000,
                        });
                      },
                    );
                  },
                },
                // button to cancel
                {
                  text: "x",
                  color: "white",
                  cssClass: "otp-close",
                  onClick: (dialog, e) => {
                    this.$f7.preloader.hide();
                  },
                },
                // button to continue
                {
                  text: "Continue",
                  bold: true,
                  cssClass: "otp-continue",
                  keyCodes: [13],
                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    // password
                    const password = dialog.$el
                      .find(".dialog-input-for-per-city")
                      .val();

                    // Verify otp
                    verifyEasychawOneTimePassword(
                      {
                        password,
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, success) => {
                        if (error || !success) {
                          throw error;
                        }

                        // close dialog
                        dialog.close();
                        this.props.firestore
                          .collection("settings")
                          .doc("easychaw")
                          .update({ deliveryChargesPerCity: updateData })
                          .then(() => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: `Settings updated`,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                            this.setState({
                              ...this.state,
                              deliveryCityPrice: {
                                country: "Nigeria",
                                state: "",
                                city: "",
                                below2Km: 0,
                                perKm: 0,
                              },
                            });
                          })
                          .catch((error) => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          });
                      },
                    );
                  },
                },
              ],
            })
            .open();
        },
      );
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  async addDeliveryCityPrice() {
    this.$f7.preloader.show();
    try {
      const newCityDeliveryPrice = this.state.deliveryCityPrice;

      for (let key in newCityDeliveryPrice) {
        if (!newCityDeliveryPrice[key]) {
          throw new Error("All fields are required.");
        }

        if (key === "below2km" || key === "perkm") {
          if (
            isNaN(Number(newCityDeliveryPrice[key])) ||
            Number(newCityDeliveryPrice[key]) <= 0
          ) {
            throw new Error(`Invalid field: ${key}`);
          }
        }
      }

      const updateData = {
        ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity,
        [newCityDeliveryPrice.country]: {
          ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
            newCityDeliveryPrice.country
          ],
          [newCityDeliveryPrice.state]: {
            ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
              newCityDeliveryPrice.country
            ]?.[newCityDeliveryPrice.state],
            [newCityDeliveryPrice.city]: {
              ...this.props.data?.settings?.easychaw?.deliveryChargesPerCity?.[
                newCityDeliveryPrice.country
              ]?.[newCityDeliveryPrice.state]?.[newCityDeliveryPrice.city],
              deliveryCharge: Number(newCityDeliveryPrice.below2Km),
              kmPerDeliveryCharge: Number(newCityDeliveryPrice.perKm),
            },
          },
        },
      };

      const idToken = await this.props.firebase
        .auth()
        .currentUser.getIdToken(true);
      sendEasychawOneTimePassword(
        { token: idToken, uid: this.props.auth.uid },
        (error, sent) => {
          if (error || !sent) {
            throw error;
          }

          this.$f7.preloader.hide();
          this.$f7.dialog
            .create({
              title: "OTP CODE",
              cssClass: "otp-code-modal",
              text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
              content: `<input class="dialog-input-for-per-city split-input" type="password" maxlength="4" />`,
              buttons: [
                // button to resend otp
                {
                  text: "Resend Code",
                  color: "gray",
                  cssClass: "otp-resend",

                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    sendEasychawOneTimePassword(
                      {
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, sent) => {
                        if (error || !sent) {
                          throw error;
                        }

                        this.$f7.preloader.hide();
                        return toast(this.$f7.toast, {
                          text: "OTP code sent",
                          position: "bottom",
                          horizontalPosition: "center",
                          closeButton: true,
                          cssClass: "custom-toast",
                          closeTimeout: 4000,
                        });
                      },
                    );
                  },
                },
                // button to cancel
                {
                  text: "x",
                  color: "white",
                  cssClass: "otp-close",
                  onClick: (dialog, e) => {
                    this.$f7.preloader.hide();
                  },
                },
                // button to continue
                {
                  text: "Continue",
                  bold: true,
                  cssClass: "otp-continue",
                  keyCodes: [13],
                  close: false,
                  onClick: (dialog, e) => {
                    this.$f7.preloader.show();
                    // password
                    const password = dialog.$el
                      .find(".dialog-input-for-per-city")
                      .val();

                    // Verify otp
                    verifyEasychawOneTimePassword(
                      {
                        password,
                        token: idToken,
                        uid: this.props.auth.uid,
                      },
                      (error, success) => {
                        if (error || !success) {
                          throw error;
                        }

                        // close dialog
                        dialog.close();
                        this.props.firestore
                          .collection("settings")
                          .doc("easychaw")
                          .update({ deliveryChargesPerCity: updateData })
                          .then(() => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: `Settings updated`,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                            this.setState({
                              ...this.state,
                              deliveryCityPrice: {
                                country: "Nigeria",
                                state: "",
                                city: "",
                                below2Km: 0,
                                perKm: 0,
                              },
                            });
                          })
                          .catch((error) => {
                            this.$f7.preloader.hide();
                            toast(this.$f7.toast, {
                              text: handleErrors(error),
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          });
                      },
                    );
                  },
                },
              ],
            })
            .open();
        },
      );
    } catch (error) {
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: error?.code ? handleErrors(error) : error.message,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }
  }

  changeDefaultSettings(e, change) {
    this.$f7.preloader.show();

    // get all current state for comparism
    const currentState = {
      defaultSearchRadius: this.state.defaultSearchRadius,
      defaultDeliveryCharge: this.state.defaultDeliveryCharge,
      perKmDeliveryCharge: this.state.perKmDeliveryCharge,
      deliveryChargeMultiplier: { ...this.state.deliveryChargeMultiplier },
      percentageOrdersBelowAThousand: this.state.percentageOrdersBelowAThousand,
      percentageOrdersAboveAThousand: this.state.percentageOrdersAboveAThousand,
      deliveryInclusiveLimit: this.state.deliveryInclusiveLimit,
    };

    // compare current state with db state
    let update = {};
    if (!this.props.ordered.settings) {
      Object.keys(currentState).forEach((key) => {
        if (key === "deliveryChargeMultiplier") {
          Object.keys(currentState[key]).forEach((subKey) => {
            if (currentState[key][subKey] !== "") {
              update[key] = {
                ...update[key],
                [subKey]: parseFloat(currentState[key][subKey]),
              };
            }
          });
        } else if (currentState[key] !== "") {
          update[key] = parseFloat(currentState[key]);
        } else {
          switch (key) {
            case "defaultDeliveryCharge":
              update[key] = 500;
              break;

            case "perKmDeliveryCharge":
              update[key] = 50;
              break;

            case "defaultDeliveryChargeMultiplier":
              update[key] = 1;
              break;

            case "percentageOrdersAboveAThousand":
              update[key] = 3.95;
              break;

            case "percentageOrdersBelowAThousand":
              update[key] = 2.55;
              break;

            default:
              update[key] = 50;
              break;
          }
        }
      });
    } else {
      Object.keys(currentState).forEach((key) => {
        if (key === "deliveryChargeMultiplier") {
          Object.keys(currentState[key]).forEach((subKey) => {
            if (currentState[key][subKey] !== "") {
              update[key] = {
                ...this.props.data.settings.easychaw[key],
                [subKey]: parseFloat(currentState[key][subKey]),
              };
            }
          });
        }

        if (
          key !== "deliveryChargeMultiplier" &&
          currentState[key] !== "" &&
          parseFloat(currentState[key]) !==
            parseFloat(this.props.data.settings.easychaw[key])
        ) {
          update[key] = parseFloat(currentState[key]);
        }
      });
    }

    if (Object.keys(update).length < 1) {
      this.$f7.preloader.hide();
      this.setState({
        ...this.state,
        defaultSearchRadius: "",
        defaultDeliveryCharge: "",
        perKmDeliveryCharge: "",
        deliveryChargeMultiplier: this.deliveryChargeMultiplierReset(),
        percentageOrdersBelowAThousand: "",
        percentageOrdersAboveAThousand: "",
        deliveryInclusiveLimit: "",
      });

      return toast(this.$f7.toast, {
        text: `Settings updated`,
        position: "bottom",
        horizontalPosition: "center",
        closeButton: true,
        cssClass: "custom-toast",
        closeTimeout: 4000,
      });
    }

    // if update is valid
    // send otp mail
    this.props.firebase
      .auth()
      .currentUser.getIdToken(true)
      .then((idToken) => {
        // send OTP to Easychaw's email
        sendEasychawOneTimePassword(
          { token: idToken, uid: this.props.auth.uid },
          (error, sent) => {
            if (error || !sent) {
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: error,
                position: "bottom",
                horizontalPosition: "center",
                closeButton: true,
                cssClass: "custom-toast",
                closeTimeout: 4000,
              });
            }

            // open a dialog to confirm OTP
            this.$f7.preloader.hide();
            this.$f7.dialog
              .create({
                title: "OTP CODE",
                cssClass: "otp-code-modal",
                text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
                content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                buttons: [
                  // button to resend otp
                  {
                    text: "Resend Code",
                    color: "gray",
                    cssClass: "otp-resend",

                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      sendEasychawOneTimePassword(
                        {
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, sent) => {
                          if (error || !sent) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: "OTP code sent",
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        },
                      );
                    },
                  },
                  // button to cancel
                  {
                    text: "x",
                    color: "white",
                    cssClass: "otp-close",
                    onClick: (dialog, e) => {
                      this.$f7.preloader.hide();
                    },
                  },
                  // button to continue
                  {
                    text: "Continue",
                    bold: true,
                    cssClass: "otp-continue",
                    keyCodes: [13],
                    close: false,
                    onClick: (dialog, e) => {
                      this.$f7.preloader.show();
                      // password
                      const password = dialog.$el.find(".dialog-input").val();

                      // Verify otp
                      verifyEasychawOneTimePassword(
                        {
                          password,
                          token: idToken,
                          uid: this.props.auth.uid,
                        },
                        (error, success) => {
                          if (error || !success) {
                            this.$f7.preloader.hide();
                            return toast(this.$f7.toast, {
                              text: error,
                              position: "bottom",
                              horizontalPosition: "center",
                              closeButton: true,
                              cssClass: "custom-toast",
                              closeTimeout: 4000,
                            });
                          }

                          // close dialog
                          dialog.close();
                          if (!this.props.ordered.settings) {
                            this.props.firestore
                              .collection("settings")
                              .doc("easychaw")
                              .set(update)
                              .then(() => {
                                this.$f7.preloader.hide();
                                toast(this.$f7.toast, {
                                  text: `Settings updated`,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });

                                this.setState({
                                  ...this.state,
                                  defaultDeliveryCharge: "",
                                  perKmDeliveryCharge: "",
                                  deliveryChargeMultiplier:
                                    this.deliveryChargeMultiplierReset(),
                                  percentageOrdersBelowAThousand: "",
                                  percentageOrdersAboveAThousand: "",
                                  deliveryInclusiveLimit: "",
                                });
                              })
                              .catch((error) => {
                                this.$f7.preloader.hide();
                                toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              });
                          } else {
                            this.props.firestore
                              .collection("settings")
                              .doc("easychaw")
                              .update(update)
                              .then(() => {
                                this.$f7.preloader.hide();
                                toast(this.$f7.toast, {
                                  text: `Settings updated`,
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                                this.setState({
                                  ...this.state,
                                  defaultDeliveryCharge: "",
                                  perKmDeliveryCharge: "",
                                  deliveryChargeMultiplier:
                                    this.deliveryChargeMultiplierReset(),
                                  percentageOrdersBelowAThousand: "",
                                  percentageOrdersAboveAThousand: "",
                                  deliveryInclusiveLimit: "",
                                });
                              })
                              .catch((error) => {
                                this.$f7.preloader.hide();
                                toast(this.$f7.toast, {
                                  text: handleErrors(error),
                                  position: "bottom",
                                  horizontalPosition: "center",
                                  closeButton: true,
                                  cssClass: "custom-toast",
                                  closeTimeout: 4000,
                                });
                              });
                          }
                        },
                      );
                    },
                  },
                ],
              })
              .open();
          },
        );
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: "bottom",
          horizontalPosition: "center",
          closeButton: true,
          cssClass: "custom-toast",
          closeTimeout: 4000,
        });
      });
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { data, ordered },
}) => ({
  auth,
  profile,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([new Collections("settings"), new Collections("orders")]),
  connect(mapStateToProps),
);

export default enhance(Admin);
